// JQuery
require("./jquery");

// Bootstrap
require("./bootstrap");

// Select2
require("select2/dist/js/select2.min.js");

// Popper
window.Popper = require("@popperjs/core");

// Sweetalert
window.Swal = require("sweetalert2");

// Notify.js
require("./notify.min.js");

// Match Height
require("jquery-match-height/dist/jquery.matchHeight-min.js");

// Cropper JS
window.Cropper = require("cropperjs/dist/cropper.min.js");

// Owl Carousel
require("owl.carousel/dist/owl.carousel.min.js");

// Magnific Popup
require("magnific-popup/dist/jquery.magnific-popup.min.js");

// // JS UUID
window.uuid4 = require("uuid");
